import { Component, Input, OnInit } from '@angular/core';
import { Position, ReportType, SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.less']
})
export class ReportComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-animation') animation;
  @Input('skc-image-width') imageWidth = '12em';
  @Input('skc-image-height') imageHeight = '12em';
  @Input('skc-image-src') imageSrc = './assets/icons/picture.svg';
  @Input('skc-image-horizontal') imageHorizontal = Position.LEFT;
  @Input('skc-image-vertical') imageVertical = Position.TOP;
  @Input('skc-report-type') report = ReportType.ARTICLE;
  reportType = ReportType;

  constructor() {
    super();
  }

  ngOnInit() {}
}
